import IntroHead from "@/assets/img/palmistry/scan/intro_head.webp"

import { scanCopy } from "../config/copy"

interface CreateReportModalProps {
  onNotNow: () => void
  onStart: () => void
}

/** Intro sheet inviting the user to scan their palm. Ported from CreatePalmReportModal. */
export function CreateReportModal({ onNotNow, onStart }: CreateReportModalProps) {
  return (
    <div className="fixed inset-0 z-[1000] mx-auto min-h-[100dvh] w-full max-w-app animate-in overflow-hidden backdrop-blur-[10px] fade-in">
      <div className="absolute inset-x-0 bottom-0 flex animate-in flex-col items-center gap-4 rounded-t-3xl bg-dark-surface pb-4 slide-in-from-bottom duration-300">
        <img src={IntroHead} alt="" className="w-full object-contain mix-blend-lighten" />

        <div className="flex w-full flex-col items-center gap-2 px-4">
          <h2 className="text-center font-display text-2xl font-medium text-purple-light">
            {scanCopy.intro.title}
          </h2>
          <p className="text-center font-body text-base text-purple-light/70">
            {scanCopy.intro.subtitle}
          </p>
        </div>

        <div className="flex w-full gap-3 px-4">
          <button
            type="button"
            onClick={onNotNow}
            className="flex h-14 flex-1 items-center justify-center rounded-[80px] bg-purple-light/10 font-body text-base font-semibold text-purple-light"
          >
            {scanCopy.intro.notNow}
          </button>
          <button
            type="button"
            onClick={onStart}
            className="flex h-14 flex-1 items-center justify-center rounded-[80px] bg-gradient-to-b from-peach to-purple-accent font-body text-base font-semibold text-white"
          >
            {scanCopy.intro.start}
          </button>
        </div>
      </div>
    </div>
  )
}
